import { withStatusOrder } from './utils';

const OPTLAP01 = {
    header: {
        en: 'Chat Initiated',
        hi: 'चैट प्रारंभ',
        kn: 'ಚಾಟ್ ಆರಂಭಿಸಲಾಗಿದೆ',
        ta: 'உரையாடல் தொடங்கப்பட்டது',
        te: 'చాట్ ప్రారంభించబడింది'
    },
    label: {
        en: 'Enquiry Creation Pending',
        hi: 'जांच निर्माण लंबित',
        kn: 'ವಿಚರಣೆ ಸೃಷ್ಟಿ ಬಾಕಿ',
        ta: 'வினவல் உருவாக்கம் நிலுவையில் உள்ளது',
        te: 'విచారణ సృష్టి పెండింగ్‌లో ఉంది'
    },
    order: 1,
    color: 'info',
    description: {
        en: 'The customer has received the WhatsApp flow. Awaiting flow submission.',
        hi: 'ग्राहक ने व्हाट्सएप प्रवाह प्राप्त कर लिया है। प्रवाह प्रस्तुत करने की प्रतीक्षा कर रहा है।',
        kn: 'ಗ್ರಾಹಕನು ವಾಟ್ಸಾಪ್ ಫ್ಲೋ ಸ್ವೀಕರಿಸಿದ್ದಾರೆ. ಫ್ಲೋ ಸಲ್ಲಿಕೆಗೆ ನಿರೀಕ್ಷಿಸಲಾಗಿದೆ.',
        ta: 'வாடிக்கையாளர் WhatsApp ஓட்டை பெற்றுள்ளார். ஓட்டை சமர்ப்பிக்க வேண்டும்.',
        te: 'కస్టమర్ WhatsApp ఫ్లో స్వీకరించాడు. ఫ్లో సమర్పణ కోసం వేచి ఉంది.'
    },
    reminder: {
        en: 'Hi {}! I see you are applying for a {} with Optimo Capital. Let me know if you need any help!\n\nClick the link to continue.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        hi: 'नमस्ते, {}! हमने देखा कि आप {} के लिए आवेदन कर रहे हैं Optimo Capital के साथ। यदि आपको किसी सहायता की आवश्यकता हो, तो हमें बताएं!\n\nजारी रखने के लिए लिंक पर क्लिक करें।\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        kn: 'ನಮಸ್ಕಾರ, {}! ನೀವು Optimo Capital ನೊಂದಿಗೆ {} ಗೆ ಅರ್ಜಿ ಹಾಕುತ್ತಿರುವುದು ನಮಗೆ ಗಮನಕ್ಕೆ ಬಂದಿದೆ. ನಿಮ್ಮಿಗೆ ಯಾವುದೇ ಸಹಾಯ ಬೇಕಾದರೆ ನಮಗೆ ತಿಳಿಸಿ!\n\nಮುಂದುವರಿಸಲು ಲಿಂಕ್ ಕ್ಲಿಕ್ ಮಾಡಿ.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        ta: 'வணக்கம், {}! நீங்கள் Optimo Capital உடன் {} க்கு விண்ணப்பித்துள்ளீர்கள் என்பதை நாங்கள் கவனித்தோம். உங்களுக்கு உதவி தேவையெனில், எங்களிடம் சொல்லுங்கள்!\n\nதொடர லிங்க் கிளிக் செய்யவும்.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        te: 'హలో, {}! మీరు Optimo Capital తో {} కోసం దరఖాస్తు చేసుకున్నారని మేము గమనించాము. మీకు ఏదైనా సహాయం కావాలంటే, మాకు చెప్పండి!\n\nకొనసాగించడానికి లింక్‌ను క్లిక్ చేయండి.\n\nwa.me/{optimo_whatsapp_number}?text=Continue'
    }
};

const OPTLAP02 = {
    header: {
        en: 'Enquiry Created',
        hi: 'जांच बनाई गई',
        kn: 'ವಿಚರಣೆ ರಚಿಸಲಾಗಿದೆ',
        ta: 'வினவல் உருவாக்கப்பட்டது',
        te: 'విచారణ సృష్టించబడింది'
    },
    label: {
        en: 'Income Details Pending',
        hi: 'आय का विवरण लंबित',
        kn: 'ಆದಾಯದ ವಿವರಗಳು ಬಾಕಿ',
        ta: 'வருமான விவரங்கள் நிலுவையில் உள்ளது',
        te: 'ఆదాయ వివరాలు పెండింగ్‌లో ఉన్నాయి'
    },
    order: 2,
    color: 'info',
    description: {
        en: 'The customer has submitted the WhatsApp flow.',
        hi: 'ग्राहक ने व्हाट्सएप प्रवाह प्रस्तुत कर दिया है।',
        kn: 'ಗ್ರಾಹಕನು ವಾಟ್ಸಾಪ್ ಫ್ಲೋ ಸಲ್ಲಿಸಿದ್ದಾರೆ.',
        ta: 'வாடிக்கையாளர் WhatsApp ஓட்டை சமர்ப்பித்துள்ளார்.',
        te: 'కస్టమర్ WhatsApp ఫ్లో సమర్పించాను.'
    },
    reminder: {
        en: 'Hi {}! I see you are applying for a {} with Optimo Capital. Let me know if you need any help!\n\nClick the link to continue.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        hi: 'नमस्ते, {}! हमने देखा कि आप {} के लिए आवेदन कर रहे हैं Optimo Capital के साथ। यदि आपको किसी सहायता की आवश्यकता हो, तो हमें बताएं!\n\nजारी रखने के लिए लिंक पर क्लिक करें।\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        kn: 'ನಮಸ್ಕಾರ, {}! ನೀವು Optimo Capital ನೊಂದಿಗೆ {} ಗೆ ಅರ್ಜಿ ಹಾಕುತ್ತಿರುವುದು ನಮಗೆ ಗಮನಕ್ಕೆ ಬಂದಿದೆ. ನಿಮ್ಮಿಗೆ ಯಾವುದೇ ಸಹಾಯ ಬೇಕಾದರೆ ನಮಗೆ ತಿಳಿಸಿ!\n\nಮುಂದುವರಿಸಲು ಲಿಂಕ್ ಕ್ಲಿಕ್ ಮಾಡಿ.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        ta: 'வணக்கம், {}! நீங்கள் Optimo Capital உடன் {} க்கு விண்ணப்பித்துள்ளீர்கள் என்பதை நாங்கள் கவனித்தோம். உங்களுக்கு உதவி தேவையெனில், எங்களிடம் சொல்லுங்கள்!\n\nதொடர லிங்க் கிளிக் செய்யவும்.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        te: 'హలో, {}! మీరు Optimo Capital తో {} కోసం దరఖాస్తు చేసుకున్నారని మేము గమనించాము. మీకు ఏదైనా సహాయం కావాలంటే, మాకు చెప్పండి!\n\nకొనసాగించడానికి లింక్‌ను క్లిక్ చేయండి.\n\nwa.me/{optimo_whatsapp_number}?text=Continue'
    }
};

const OPTLAP03 = {
    header: {
        en: 'Income Details',
        hi: 'आय विवरण',
        kn: 'ಆದಾಯದ ವಿವರಗಳು',
        ta: 'வருமான விவரங்கள்',
        te: 'ఆదాయ వివరాలు'
    },
    label: {
        en: 'Property Details Pending',
        hi: 'संपत्ति का विवरण लंबित',
        kn: 'ಆಸ್ತಿ ವಿವರಗಳು ಬಾಕಿ',
        ta: 'சொத்து விவரங்கள் நிலுவையில் உள்ளது',
        te: 'ఆస్తి వివరాలు పెండింగ్‌లో ఉన్నాయి'
    },
    order: 3,
    color: 'info',
    description: {
        en: 'The customer has filled the income and expense details.',
        hi: 'ग्राहक ने आय और व्यय का विवरण भरा है।',
        kn: 'ಗ್ರಾಹಕನು ಆದಾಯ ಮತ್ತು ವೆಚ್ಚದ ವಿವರಗಳನ್ನು ತುಂಬಿದ್ದಾರೆ.',
        ta: 'வாடிக்கையாளர் வருமான மற்றும் செலவு விவரங்களை நிரப்பியுள்ளார்.',
        te: 'కస్టమర్ ఆదాయం మరియు ఖర్చుల వివరాలను పూరించాడు.'
    },
    reminder: {
        en: 'Hi {}! I see you are applying for a {} with Optimo Capital. Let me know if you need any help!\n\nClick the link to continue.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        hi: 'नमस्ते, {}! हमने देखा कि आप {} के लिए आवेदन कर रहे हैं Optimo Capital के साथ। यदि आपको किसी सहायता की आवश्यकता हो, तो हमें बताएं!\n\nजारी रखने के लिए लिंक पर क्लिक करें।\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        kn: 'ನಮಸ್ಕಾರ, {}! ನೀವು Optimo Capital ನೊಂದಿಗೆ {} ಗೆ ಅರ್ಜಿ ಹಾಕುತ್ತಿರುವುದು ನಮಗೆ ಗಮನಕ್ಕೆ ಬಂದಿದೆ. ನಿಮ್ಮಿಗೆ ಯಾವುದೇ ಸಹಾಯ ಬೇಕಾದರೆ ನಮಗೆ ತಿಳಿಸಿ!\n\nಮುಂದುವರಿಸಲು ಲಿಂಕ್ ಕ್ಲಿಕ್ ಮಾಡಿ.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        ta: 'வணக்கம், {}! நீங்கள் Optimo Capital உடன் {} க்கு விண்ணப்பித்துள்ளீர்கள் என்பதை நாங்கள் கவனித்தோம். உங்களுக்கு உதவி தேவையெனில், எங்களிடம் சொல்லுங்கள்!\n\nதொடர லிங்க் கிளிக் செய்யவும்.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        te: 'హలో, {}! మీరు Optimo Capital తో {} కోసం దరఖాస్తు చేసుకున్నారని మేము గమనించాము. మీకు ఏదైనా సహాయం కావాలంటే, మాకు చెప్పండి!\n\nకొనసాగించడానికి లింక్‌ను క్లిక్ చేయండి.\n\nwa.me/{optimo_whatsapp_number}?text=Continue'
    }
};

const OPTLAP04 = {
    header: {
        en: 'Property Details',
        hi: 'संपत्ति विवरण',
        kn: 'ಆಸ್ತಿ ವಿವರಗಳು',
        ta: 'சொத்து விவரங்கள்',
        te: 'ఆస్తి వివరాలు'
    },
    label: {
        en: 'Property Location Pending',
        hi: 'संपत्ति स्थान लंबित',
        kn: 'ಆಸ್ತಿ ಸ್ಥಳ ಬಾಕಿ',
        ta: 'சொத்து இடம் நிலுவையில் உள்ளது',
        te: 'ఆస్తి స్థానం పెండింగ్‌లో ఉంది'
    },
    order: 4,
    color: 'info',
    description: {
        en: 'The customer has filled the collateral property details.',
        hi: 'ग्राहक ने संपार्श्विक संपत्ति का विवरण भरा है।',
        kn: 'ಗ್ರಾಹಕನು ಕೊಲ್ಲಟರಲ್ ಆಸ್ತಿ ವಿವರಗಳನ್ನು ತುಂಬಿದ್ದಾರೆ.',
        ta: 'வாடிக்கையாளர் அடமான சொத்து விவரங்களை நிரப்பியுள்ளார்.',
        te: 'కస్టమర్ గిరవుగా ఉన్న ఆస్తి వివరాలను పూరించాడు.'
    },
    reminder: {
        en: 'Hi {}! I see you are applying for a {} with Optimo Capital. Let me know if you need any help!\n\nClick the link to continue.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        hi: 'नमस्ते, {}! हमने देखा कि आप {} के लिए आवेदन कर रहे हैं Optimo Capital के साथ। यदि आपको किसी सहायता की आवश्यकता हो, तो हमें बताएं!\n\nजारी रखने के लिए लिंक पर क्लिक करें।\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        kn: 'ನಮಸ್ಕಾರ, {}! ನೀವು Optimo Capital ನೊಂದಿಗೆ {} ಗೆ ಅರ್ಜಿ ಹಾಕುತ್ತಿರುವುದು ನಮಗೆ ಗಮನಕ್ಕೆ ಬಂದಿದೆ. ನಿಮ್ಮಿಗೆ ಯಾವುದೇ ಸಹಾಯ ಬೇಕಾದರೆ ನಮಗೆ ತಿಳಿಸಿ!\n\nಮುಂದುವರಿಸಲು ಲಿಂಕ್ ಕ್ಲಿಕ್ ಮಾಡಿ.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        ta: 'வணக்கம், {}! நீங்கள் Optimo Capital உடன் {} க்கு விண்ணப்பித்துள்ளீர்கள் என்பதை நாங்கள் கவனித்தோம். உங்களுக்கு உதவி தேவையெனில், எங்களிடம் சொல்லுங்கள்!\n\nதொடர லிங்க் கிளிக் செய்யவும்.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        te: 'హలో, {}! మీరు Optimo Capital తో {} కోసం దరఖాస్తు చేసుకున్నారని మేము గమనించాము. మీకు ఏదైనా సహాయం కావాలంటే, మాకు చెప్పండి!\n\nకొనసాగించడానికి లింక్‌ను క్లిక్ చేయండి.\n\nwa.me/{optimo_whatsapp_number}?text=Continue'
    }
};

const OPTLAP05 = {
    header: {
        en: 'Property Location',
        hi: 'संपत्ति स्थान',
        kn: 'ಆಸ್ತಿ ಸ್ಥಳ',
        ta: 'சொத்து இடம்',
        te: 'ఆస్తి స్థానం'
    },
    label: {
        en: 'Aadhaar Verification Pending',
        hi: 'आधार सत्यापन लंबित',
        kn: 'ಆಧಾರ್ ಪರಿಶೀಲನೆ ಬಾಕಿ',
        ta: 'ஆதார் சரிபார்ப்பு நிலுவையில் உள்ளது',
        te: 'ఆధార్ ధృవీకరణ పెండింగ్‌లో ఉంది'
    },
    order: 5,
    color: 'info',
    description: {
        en: 'The customer has filled the property location details.',
        hi: 'ग्राहक ने संपत्ति स्थान का विवरण भरा है।',
        kn: 'ಗ್ರಾಹಕನು ಆಸ್ತಿ ಸ್ಥಳದ ವಿವರಗಳನ್ನು ತುಂಬಿದ್ದಾರೆ.',
        ta: 'வாடிக்கையாளர் சொத்து இட விவரங்களை நிரப்பியுள்ளார்.',
        te: 'కస్టమర్ ఆస్తి స్థానం వివరాలను పూరించాడు.'
    },
    reminder: {
        en: 'Hi {}! I see you are applying for a {} with Optimo Capital. Let me know if you need any help!\n\nClick the link to continue.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        hi: 'नमस्ते, {}! हमने देखा कि आप {} के लिए आवेदन कर रहे हैं Optimo Capital के साथ। यदि आपको किसी सहायता की आवश्यकता हो, तो हमें बताएं!\n\nजारी रखने के लिए लिंक पर क्लिक करें।\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        kn: 'ನಮಸ್ಕಾರ, {}! ನೀವು Optimo Capital ನೊಂದಿಗೆ {} ಗೆ ಅರ್ಜಿ ಹಾಕುತ್ತಿರುವುದು ನಮಗೆ ಗಮನಕ್ಕೆ ಬಂದಿದೆ. ನಿಮ್ಮಿಗೆ ಯಾವುದೇ ಸಹಾಯ ಬೇಕಾದರೆ ನಮಗೆ ತಿಳಿಸಿ!\n\nಮುಂದುವರಿಸಲು ಲಿಂಕ್ ಕ್ಲಿಕ್ ಮಾಡಿ.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        ta: 'வணக்கம், {}! நீங்கள் Optimo Capital உடன் {} க்கு விண்ணப்பித்துள்ளீர்கள் என்பதை நாங்கள் கவனித்தோம். உங்களுக்கு உதவி தேவையெனில், எங்களிடம் சொல்லுங்கள்!\n\nதொடர லிங்க் கிளிக் செய்யவும்.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        te: 'హలో, {}! మీరు Optimo Capital తో {} కోసం దరఖాస్తు చేసుకున్నారని మేము గమనించాము. మీకు ఏదైనా సహాయం కావాలంటే, మాకు చెప్పండి!\n\nకొనసాగించడానికి లింక్‌ను క్లిక్ చేయండి.\n\nwa.me/{optimo_whatsapp_number}?text=Continue'
    }
};

const OPTLAP06 = {
    header: {
        en: 'Aadhaar Verified',
        hi: 'आधार सत्यापित',
        kn: 'ಆಧಾರ್ ದೃಢೀಕರಿಸಲಾಗಿದೆ',
        ta: 'ஆதார் சரிபார்க்கப்பட்டது',
        te: 'ఆధార్ ధృవీకరించబడింది'
    },
    label: {
        en: 'PAN Verification Pending',
        hi: 'पैन सत्यापन लंबित',
        kn: 'ಪಾನ್ ಪರಿಶೀಲನೆ ಬಾಕಿ',
        ta: 'பான் சரிபார்ப்பு நிலுவையில் உள்ளது',
        te: 'పాన్ ధృవీకరణ పెండింగ్‌లో ఉంది'
    },
    order: 6,
    color: 'info',
    description: {
        en: 'The customer has verified their Aadhaar.',
        hi: 'ग्राहक ने अपना आधार सत्यापित कर लिया है।',
        kn: 'ಗ್ರಾಹಕನು ತಮ್ಮ ಆಧಾರ್ ಅನ್ನು ದೃಢೀಕರಿಸಿದ್ದಾರೆ.',
        ta: 'வாடிக்கையாளர் தனது ஆதாரைப் சரிபார்த்துள்ளார்.',
        te: 'కస్టమర్ తన ఆధార్‌ను ధృవీకరించాడు.'
    },
    reminder: {
        en: 'Hi {}! I see you are applying for a {} with Optimo Capital. Let me know if you need any help!\n\nClick the link to continue.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        hi: 'नमस्ते, {}! हमने देखा कि आप {} के लिए आवेदन कर रहे हैं Optimo Capital के साथ। यदि आपको किसी सहायता की आवश्यकता हो, तो हमें बताएं!\n\nजारी रखने के लिए लिंक पर क्लिक करें।\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        kn: 'ನಮಸ್ಕಾರ, {}! ನೀವು Optimo Capital ನೊಂದಿಗೆ {} ಗೆ ಅರ್ಜಿ ಹಾಕುತ್ತಿರುವುದು ನಮಗೆ ಗಮನಕ್ಕೆ ಬಂದಿದೆ. ನಿಮ್ಮಿಗೆ ಯಾವುದೇ ಸಹಾಯ ಬೇಕಾದರೆ ನಮಗೆ ತಿಳಿಸಿ!\n\nಮುಂದುವರಿಸಲು ಲಿಂಕ್ ಕ್ಲಿಕ್ ಮಾಡಿ.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        ta: 'வணக்கம், {}! நீங்கள் Optimo Capital உடன் {} க்கு விண்ணப்பித்துள்ளீர்கள் என்பதை நாங்கள் கவனித்தோம். உங்களுக்கு உதவி தேவையெனில், எங்களிடம் சொல்லுங்கள்!\n\nதொடர லிங்க் கிளிக் செய்யவும்.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        te: 'హలో, {}! మీరు Optimo Capital తో {} కోసం దరఖాస్తు చేసుకున్నారని మేము గమనించాము. మీకు ఏదైనా సహాయం కావాలంటే, మాకు చెప్పండి!\n\nకొనసాగించడానికి లింక్‌ను క్లిక్ చేయండి.\n\nwa.me/{optimo_whatsapp_number}?text=Continue'
    }
};

const OPTLAP07 = {
    header: {
        en: 'PAN Verified',
        hi: 'पैन सत्यापित',
        kn: 'ಪಾನ್ ದೃಢೀಕರಿಸಲಾಗಿದೆ',
        ta: 'பான் சரிபார்க்கப்பட்டது',
        te: 'పాన్ ధృవీకరించబడింది'
    },
    label: {
        en: 'Application Submitted',
        hi: 'आवेदन जमा किया गया',
        kn: 'ಅರ್ಜಿಯನ್ನು ಸಲ್ಲಿಸಲಾಗಿದೆ',
        ta: 'விண்ணப்பம் சமர்ப்பிக்கப்பட்டது',
        te: 'దరఖాస్తు సమర్పించబడింది'
    },
    order: 7,
    color: 'info',
    description: {
        en: 'The customer has verified their PAN.',
        hi: 'ग्राहक ने अपना पैन सत्यापित कर लिया है।',
        kn: 'ಗ್ರಾಹಕನು ತಮ್ಮ ಪಾನ್ ಅನ್ನು ದೃಢೀಕರಿಸಿದ್ದಾರೆ.',
        ta: 'வாடிக்கையாளர் தனது பானை சரிபார்த்துள்ளார்.',
        te: 'కస్టమర్ తన పాన్‌ను ధృవీకరించాడు.'
    },
    reminder: {
        en: 'Hi {}! I see you are applying for a {} with Optimo Capital. Let me know if you need any help!\n\nClick the link to continue.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        hi: 'नमस्ते, {}! हमने देखा कि आप {} के लिए आवेदन कर रहे हैं Optimo Capital के साथ। यदि आपको किसी सहायता की आवश्यकता हो, तो हमें बताएं!\n\nजारी रखने के लिए लिंक पर क्लिक करें।\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        kn: 'ನಮಸ್ಕಾರ, {}! ನೀವು Optimo Capital ನೊಂದಿಗೆ {} ಗೆ ಅರ್ಜಿ ಹಾಕುತ್ತಿರುವುದು ನಮಗೆ ಗಮನಕ್ಕೆ ಬಂದಿದೆ. ನಿಮ್ಮಿಗೆ ಯಾವುದೇ ಸಹಾಯ ಬೇಕಾದರೆ ನಮಗೆ ತಿಳಿಸಿ!\n\nಮುಂದುವರಿಸಲು ಲಿಂಕ್ ಕ್ಲಿಕ್ ಮಾಡಿ.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        ta: 'வணக்கம், {}! நீங்கள் Optimo Capital உடன் {} க்கு விண்ணப்பித்துள்ளீர்கள் என்பதை நாங்கள் கவனித்தோம். உங்களுக்கு உதவி தேவையெனில், எங்களிடம் சொல்லுங்கள்!\n\nதொடர லிங்க் கிளிக் செய்யவும்.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        te: 'హలో, {}! మీరు Optimo Capital తో {} కోసం దరఖాస్తు చేసుకున్నారని మేము గమనించాము. మీకు ఏదైనా సహాయం కావాలంటే, మాకు చెప్పండి!\n\nకొనసాగించడానికి లింక్‌ను క్లిక్ చేయండి.\n\nwa.me/{optimo_whatsapp_number}?text=Continue'
    }
};

const OPTLAP08 = {
    header: {
        en: 'Application Submitted',
        hi: 'आवेदन जमा किया गया',
        kn: 'ಅರ್ಜಿಯನ್ನು ಸಲ್ಲಿಸಲಾಗಿದೆ',
        ta: 'விண்ணப்பம் சமர்ப்பிக்கப்பட்டது',
        te: 'దరఖాస్తు సమర్పించబడింది',
    },
    label: {
        en: 'Awaiting Decision',
        hi: 'फैसले का इंतजार',
        kn: 'ತೀರ್ಮಾನಕ್ಕಾಗಿ ಕಾಯಲಾಗುತ್ತಿದೆ',
        ta: 'முடிவிற்காக காத்திருக்கிறது',
        te: 'నిర్ణయం కోసం వేచి ఉంది',
    },
    order: 8,
    color: 'success',
    description: {
        en: 'The customer has submitted their application.',
        hi: 'ग्राहक ने अपना आवेदन जमा कर दिया है।',
        kn: 'ಗ್ರಾಹಕನು ತಮ್ಮ ಅರ್ಜಿಯನ್ನು ಸಲ್ಲಿಸಿದ್ದಾರೆ.',
        ta: 'வாடிக்கையாளர் தனது விண்ணப்பத்தை சமர்ப்பித்துள்ளார்.',
        te: 'కస్టమర్ తన దరఖాస్తును సమర్పించాడు.',
    },
    reminder: {
        en: 'Hi {}! I see you are applying for a {} with Optimo Capital. Let me know if you need any help!\n\nClick the link to continue.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        hi: 'नमस्ते, {}! हमने देखा कि आप {} के लिए आवेदन कर रहे हैं Optimo Capital के साथ। यदि आपको किसी सहायता की आवश्यकता हो, तो हमें बताएं!\n\nजारी रखने के लिए लिंक पर क्लिक करें।\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        kn: 'ನಮಸ್ಕಾರ, {}! ನೀವು Optimo Capital ನೊಂದಿಗೆ {} ಗೆ ಅರ್ಜಿ ಹಾಕುತ್ತಿರುವುದು ನಮಗೆ ಗಮನಕ್ಕೆ ಬಂದಿದೆ. ನಿಮ್ಮಿಗೆ ಯಾವುದೇ ಸಹಾಯ ಬೇಕಾದರೆ ನಮಗೆ ತಿಳಿಸಿ!\n\nಮುಂದುವರಿಸಲು ಲಿಂಕ್ ಕ್ಲಿಕ್ ಮಾಡಿ.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        ta: 'வணக்கம், {}! நீங்கள் Optimo Capital உடன் {} க்கு விண்ணப்பித்துள்ளீர்கள் என்பதை நாங்கள் கவனித்தோம். உங்களுக்கு உதவி தேவையெனில், எங்களிடம் சொல்லுங்கள்!\n\nதொடர லிங்க் கிளிக் செய்யவும்.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        te: 'హలో, {}! మీరు Optimo Capital తో {} కోసం దరఖాస్తు చేసుకున్నారని మేము గమనించాము. మీకు ఏదైనా సహాయం కావాలంటే, మాకు చెప్పండి!\n\nకొనసాగించడానికి లింక్‌ను క్లిక్ చేయండి.\n\nwa.me/{optimo_whatsapp_number}?text=Continue'
    }
};

const OPTLAP09 = {
    header: {
        en: 'Application Rejected',
        hi: 'आवेदन अस्वीकृत',
        kn: 'ಅರ್ಜಿಯನ್ನು ತಿರಸ್ಕರಿಸಲಾಗಿದೆ',
        ta: 'விண்ணப்பம் நிராகரிக்கப்பட்டது',
        te: 'దరఖాస్తు తిరస్కరించబడింది',
    },
    label: {
        en: 'Application Rejected',
        hi: 'आवेदन अस्वीकृत',
        kn: 'ಅರ್ಜಿಯನ್ನು ತಿರಸ್ಕರಿಸಲಾಗಿದೆ',
        ta: 'விண்ணப்பம் நிராகரிக்கப்பட்டது',
        te: 'దరఖాస్తు తిరస్కరించబడింది',
    },
    order: 9,
    color: 'error',
    description: {
        en: 'The loan application has been rejected.',
        hi: 'ऋण आवेदन अस्वीकृत कर दिया गया है।',
        kn: 'ಸಾಲದ ಅರ್ಜಿಯನ್ನು ತಿರಸ್ಕರಿಸಲಾಗಿದೆ.',
        ta: 'கடன் விண்ணப்பம் நிராகரிக்கப்பட்டது.',
        te: 'రుణ దరఖాస్తు తిరస్కరించబడింది.',
    },
    reminder: {
        en: 'Hi {}! I see you are applying for a {} with Optimo Capital. Let me know if you need any help!\n\nClick the link to continue.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        hi: 'नमस्ते, {}! हमने देखा कि आप {} के लिए आवेदन कर रहे हैं Optimo Capital के साथ। यदि आपको किसी सहायता की आवश्यकता हो, तो हमें बताएं!\n\nजारी रखने के लिए लिंक पर क्लिक करें।\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        kn: 'ನಮಸ್ಕಾರ, {}! ನೀವು Optimo Capital ನೊಂದಿಗೆ {} ಗೆ ಅರ್ಜಿ ಹಾಕುತ್ತಿರುವುದು ನಮಗೆ ಗಮನಕ್ಕೆ ಬಂದಿದೆ. ನಿಮ್ಮಿಗೆ ಯಾವುದೇ ಸಹಾಯ ಬೇಕಾದರೆ ನಮಗೆ ತಿಳಿಸಿ!\n\nಮುಂದುವರಿಸಲು ಲಿಂಕ್ ಕ್ಲಿಕ್ ಮಾಡಿ.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        ta: 'வணக்கம், {}! நீங்கள் Optimo Capital உடன் {} க்கு விண்ணப்பித்துள்ளீர்கள் என்பதை நாங்கள் கவனித்தோம். உங்களுக்கு உதவி தேவையெனில், எங்களிடம் சொல்லுங்கள்!\n\nதொடர லிங்க் கிளிக் செய்யவும்.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        te: 'హలో, {}! మీరు Optimo Capital తో {} కోసం దరఖాస్తు చేసుకున్నారని మేము గమనించాము. మీకు ఏదైనా సహాయం కావాలంటే, మాకు చెప్పండి!\n\nకొనసాగించడానికి లింక్‌ను క్లిక్ చేయండి.\n\nwa.me/{optimo_whatsapp_number}?text=Continue'
    }
};

const OPTLAP10 = {
    header: {
        en: 'Application Approved',
        hi: 'आवेदन स्वीकृत',
        kn: 'ಅರ್ಜಿಯನ್ನು ಅನುಮೋದಿಸಲಾಗಿದೆ',
        ta: 'விண்ணப்பம் ஒப்புதல் பெற்றது',
        te: 'దరఖాస్తు ఆమోదించబడింది',
    },
    label: {
        en: 'Awaiting Confirmation',
        hi: 'पुष्टि की प्रतीक्षा',
        kn: 'ದೃಢೀಕರಣಕ್ಕಾಗಿ ಕಾಯಲಾಗುತ್ತಿದೆ',
        ta: 'உறுதிப்படுத்தல் நிலுவையில் உள்ளது',
        te: 'నిర్ధారణ కోసం వేచి ఉంది',
    },
    order: 10,
    color: 'success',
    description: {
        en: 'The loan application has been approved.',
        hi: 'ऋण आवेदन स्वीकृत हो गया है।',
        kn: 'ಸಾಲದ ಅರ್ಜಿ ಅನುಮೋದಿಸಲಾಗಿದೆ.',
        ta: 'கடன் விண்ணப்பம் ஒப்புதல் பெற்றது.',
        te: 'రుణ దరఖాస్తు ఆమోదించబడింది.',
    },
    reminder: {
        en: 'Hi {}! I see you are applying for a {} with Optimo Capital. Let me know if you need any help!\n\nClick the link to continue.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        hi: 'नमस्ते, {}! हमने देखा कि आप {} के लिए आवेदन कर रहे हैं Optimo Capital के साथ। यदि आपको किसी सहायता की आवश्यकता हो, तो हमें बताएं!\n\nजारी रखने के लिए लिंक पर क्लिक करें।\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        kn: 'ನಮಸ್ಕಾರ, {}! ನೀವು Optimo Capital ನೊಂದಿಗೆ {} ಗೆ ಅರ್ಜಿ ಹಾಕುತ್ತಿರುವುದು ನಮಗೆ ಗಮನಕ್ಕೆ ಬಂದಿದೆ. ನಿಮ್ಮಿಗೆ ಯಾವುದೇ ಸಹಾಯ ಬೇಕಾದರೆ ನಮಗೆ ತಿಳಿಸಿ!\n\nಮುಂದುವರಿಸಲು ಲಿಂಕ್ ಕ್ಲಿಕ್ ಮಾಡಿ.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        ta: 'வணக்கம், {}! நீங்கள் Optimo Capital உடன் {} க்கு விண்ணப்பித்துள்ளீர்கள் என்பதை நாங்கள் கவனித்தோம். உங்களுக்கு உதவி தேவையெனில், எங்களிடம் சொல்லுங்கள்!\n\nதொடர லிங்க் கிளிக் செய்யவும்.\n\nwa.me/{optimo_whatsapp_number}?text=Continue',
        te: 'హలో, {}! మీరు Optimo Capital తో {} కోసం దరఖాస్తు చేసుకున్నారని మేము గమనించాము. మీకు ఏదైనా సహాయం కావాలంటే, మాకు చెప్పండి!\n\nకొనసాగించడానికి లింక్‌ను క్లిక్ చేయండి.\n\nwa.me/{optimo_whatsapp_number}?text=Continue'
    }
};

const OPTLAP11 = {
    header: {
        en: 'Account Details',
        hi: 'खाता विवरण',
        kn: 'ಖಾತೆ ವಿವರಗಳು',
        ta: 'கணக்கு விவரங்கள்',
        te: 'ఖాతా వివరాలు',
    },
    label: {
        en: 'Account Details',
        hi: 'खाता विवरण',
        kn: 'ಖಾತೆ ವಿವರಗಳು',
        ta: 'கணக்கு விவரங்கள்',
        te: 'ఖాతా వివరాలు',
    },
    order: 12,
    color: 'success',
    description: {
        en: 'Accounts linked.',
        hi: 'खाते जुड़ गए हैं।',
        kn: 'ಖಾತೆಗಳು ಲಿಂಕ್ ಆಗಿವೆ.',
        ta: 'கணக்குகள் இணைக்கப்பட்டுள்ளன.',
        te: 'ఖాతాలు లింక్ చేయబడ్డాయి.',
    },
    reminder: {
        en: 'Hi, {}! Thank you for submitting your bank statements. We are now verifying your account details for the approval process.',
        hi: 'नमस्ते, {}! अपने बैंक स्टेटमेंट जमा करने के लिए धन्यवाद। हम अनुमोदन प्रक्रिया के लिए आपके खाते के विवरण का सत्यापन कर रहे हैं।',
        kn: 'ನಮಸ್ಕಾರ, {}! ನಿಮ್ಮ ಬ್ಯಾಂಕ್ ಸ್ಟೇಟ್‌ಮೆಂಟ್‌ಗಳನ್ನು ಸಲ್ಲಿಸಿದ್ದಕ್ಕೆ ಧನ್ಯವಾದಗಳು. ಅನುಮೋದನೆ ಪ್ರಕ್ರಿಯೆಗಾಗಿ ನಾವೀಗ ನಿಮ್ಮ ಖಾತೆ ವಿವರಗಳನ್ನು ಪರಿಶೀಲಿಸುತ್ತಿದ್ದೇವೆ.',
        ta: 'வணக்கம், {}! உங்கள் வங்கி அறிக்கைகளை சமர்ப்பித்தமைக்கு நன்றி. ஒப்புதல் செயல்முறைக்காக உங்கள் கணக்கு விவரங்களை இப்போது சரிபார்க்கிறோம்.',
        te: 'హలో, {}! మీ బ్యాంకు స్టేట్‌మెంట్‌లను సమర్పించినందుకు ధన్యవాదాలు. ఆమోదం ప్రక్రియ కోసం మేము ఇప్పుడు మీ ఖాతా వివరాలను ధృవీకరిస్తున్నాము.',
    }
};

const OPTLAP12 = {
    header: {
        en: 'Digio KYC',
        hi: 'डिजियो केवाईसी',
        kn: 'ಡಿಜಿಯೋ ಕೆವೈಸಿ',
        ta: 'டிஜியோ கேஒய்சி',
        te: 'డిజియో కేవైసీ',
    },
    label: {
        en: 'Digio KYC',
        hi: 'डिजियो केवाईसी',
        kn: 'ಡಿಜಿಯೋ ಕೆವೈಸಿ',
        ta: 'டிஜியோ கேஒய்சி',
        te: 'డిజియో కేవైసీ',
    },
    order: 11,
    color: 'info',
    description: {
        en: 'The customer has verified their KYC.',
        hi: 'ग्राहक ने अपना केवाईसी सत्यापित किया है।',
        kn: 'ಗ್ರಾಹಕ ತಮ್ಮ ಕೆವೈಸಿ ಅನ್ನು ದೃಢೀಕರಿಸಿದ್ದಾರೆ.',
        ta: 'வாடிக்கையாளர் தனது கேஒய்சியை சரிபார்த்துள்ளார்.',
        te: 'కస్టమర్ తన కేవైసీని ధృవీకరించాడు.',
    },
};

export const SBLActiveCases = withStatusOrder({
    OPTLAP01,
    OPTLAP02,
    OPTLAP03,
    OPTLAP04,
    OPTLAP05,
    OPTLAP06,
    OPTLAP07,
    OPTLAP12,
    OPTLAP11,
});

export const SBLContinueJourneyCases = withStatusOrder({
    OPTLAP02,
    OPTLAP03,
    OPTLAP04,
    OPTLAP05,
    OPTLAP06,
    OPTLAP07,
    OPTLAP12,
    OPTLAP11,
});

export const SBLSanction = withStatusOrder({
    OPTLAP08,
});

export const SBLRejected = withStatusOrder({
    OPTLAP01,
    OPTLAP02,
    OPTLAP03,
    OPTLAP04,
    OPTLAP05,
    OPTLAP06,
    OPTLAP07,
    OPTLAP12,
    OPTLAP11,
    // OPTLAP09,
});

export const SBLCancelled = withStatusOrder({
    OPTLAP01,
    OPTLAP02,
    OPTLAP03,
    OPTLAP04,
    OPTLAP05,
    OPTLAP06,
    OPTLAP07,
    OPTLAP12,
    OPTLAP11,
})


const OPTLAP02_UNSERVICEABLE = {
    ...OPTLAP02,
    header: {
        ...OPTLAP02.header,
        en: 'Unserviceable',
        hi: OPTLAP02.header.hi,
        kn: OPTLAP02.header.kn,
        ta: OPTLAP02.header.ta,
        te: OPTLAP02.header.te
    }
};

export const SBLUnserviceable = withStatusOrder({
    OPTLAP02: OPTLAP02_UNSERVICEABLE
})

export const getSBLAll = (currentStatusCode) => {
    let SBLAll = {
        OPTLAP01,
        OPTLAP02,
        OPTLAP03,
        OPTLAP04,
        OPTLAP05,
        OPTLAP06,
        OPTLAP07,
        OPTLAP11,
        OPTLAP12,
        OPTLAP08,
    };

    if (currentStatusCode === 'OPTLAP09') {
        SBLAll = {
            ...SBLAll,
            OPTLAP09,
        }
    } else if (currentStatusCode === 'OPTLAP10') {
        SBLAll = {
            ...SBLAll,
            OPTLAP10,
        }
    } else {
        SBLAll = {
            ...SBLAll,
            OPTLAPXX: {
                header: {
                    en: 'Awaiting Decision',
                    hi: 'फैसले का इंतजार',
                    kn: 'ತೀರ್ಮಾನಕ್ಕಾಗಿ ಕಾಯಲಾಗುತ್ತಿದೆ',
                    ta: 'முடிவிற்காக காத்திருக்கிறது',
                    te: 'నిర్ణయం కోసం వేచి ఉంది',
                },
                color: 'success',
            },
        }
    }

    return withStatusOrder(SBLAll);
};
